import React, { useState, useEffect } from 'react';
import { Flex, Typography } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import { setHeaderTitleCallback, setShowBackButtonCallback, getCustomBackHandler } from '../../hooks/useHeaderTitle';
import logo from '../../assets/images/logo.png';
import './HeaderBar.less';

const HeaderBar = ({ style }) => {
	const [title, setTitle] = useState('金飯碗 Gold Rice Bowl');
	const [showBackButton, setShowBackButton] = useState(false);
	const history = useHistory();

	useEffect(() => {
		// Register the callbacks for child components to update
		setHeaderTitleCallback(setTitle);
		setShowBackButtonCallback(setShowBackButton);

		return () => {
			// Cleanup: unregister callbacks on unmount
			setHeaderTitleCallback(null);
			setShowBackButtonCallback(null);
		};
	}, []);

	const handleBack = () => {
		const customHandler = getCustomBackHandler();

		// custom handle for not-found page
		console.log(window.location.pathname);
		if (
			window.location.pathname.includes('/not-found')
			|| window.location.pathname.includes('/terms')
		) {
			history.push('/booking');
			return;
		}

		if (customHandler) {
			customHandler();
		} else {
			history.goBack();
		}
	};

	return (
		<Flex
			justify="center"
			align="center"
			className="header-bar-container"
			style={{ position: 'relative', ...style }}
		>
			<Flex
				align="center"
				className="header-bar-content"
			>
				{
					showBackButton
					&& !window.location.pathname.includes('/receipt')
					&& (
						<div
							className="header-back-button"
							onClick={handleBack}
						>
							<LeftOutlined />
						</div>
					)
				}
				<img
					src={logo}
					alt="Logo"
					className="header-logo"
				/>
				<Typography.Text className="header-title">{title}</Typography.Text>
			</Flex>
		</Flex>
	);
};

export default HeaderBar;
